// The FD and BD of the PWA Kit may have different ways of importing/exporting constants/functions.
// An example of this is the case of the 'react-intl' library. This library is imported in the PWA Kit
// as a function, while in the BD it is imported as an object.
// As result of this, we must have a unique constants file for all files that are linked to the SSR.

export const PAYMENT_METHODS = {
    ADYEN_COMPONENT: 'AdyenComponent',
    CREDIT_CARD: 'CREDIT_CARD'
}

export const PAYMENT_METHOD_TYPES = {
    GIFT_CARD: 'giftcard',
    WECHATPAY_MINI_PROGRAM: 'wechatpayMiniProgram',
    WECHATPAY_QR: 'wechatpayQR',
    WECHATPAY_SDK: 'wechatpaySDK',
    IDEAL: 'ideal'
}

export const RESULT_CODES = {
    AUTHORISED: 'Authorised',
    CANCELLED: 'Cancelled',
    CHALLENGESHOPPER: 'ChallengeShopper',
    ERROR: 'Error',
    IDENTIFYSHOPPER: 'IdentifyShopper',
    PENDING: 'Pending',
    PRESENTTOSHOPPER: 'PresentToShopper',
    RECEIVED: 'Received',
    REDIRECTSHOPPER: 'RedirectShopper',
    REFUSED: 'Refused'
}

export const BLOCKED_PAYMENT_METHODS = [
    PAYMENT_METHOD_TYPES.GIFT_CARD,
    PAYMENT_METHOD_TYPES.WECHATPAY_MINI_PROGRAM,
    PAYMENT_METHOD_TYPES.WECHATPAY_QR,
    PAYMENT_METHOD_TYPES.WECHATPAY_SDK,
    PAYMENT_METHOD_TYPES.IDEAL
]

export const ADYEN_BLOCKED_PAYMENT_METHODS = [
    'bcmc_mobile_QR',
    'alipay_wap',
    'wechatpayMiniProgram',
    'wechatpaySDK',
    'wechatpayWeb'
]

export const SHOPPER_INTERACTIONS = {
    CONT_AUTH: 'ContAuth',
    ECOMMERCE: 'Ecommerce'
}

export const RECURRING_PROCESSING_MODEL = {
    CARD_ON_FILE: 'CardOnFile'
}

export const ADYEN_LIVE_REGIONS = {
    LIVE_EU: 'live',
    LIVE_APSE: 'live-apse',
    LIVE_AU: 'live-au',
    LIVE_US: 'live-us',
    LIVE_IN: 'live-in'
}

export const ADYEN_ENVIRONMENT = {
    LIVE: 'LIVE',
    TEST: 'TEST'
}

export const ORDER = Object.freeze({
    ORDER_STATUS_CREATED: 'created',
    ORDER_STATUS_NEW: 'new',
    ORDER_STATUS_COMPLETED: 'completed',
    ORDER_STATUS_CANCELED: 'cancelled',
    ORDER_STATUS_FAILED: 'failed',
    PAYMENT_STATUS_PAID: 'paid',
    PAYMENT_STATUS_PART_PAID: 'part_paid',
    PAYMENT_STATUS_NOT_PAID: 'not_paid',
    EXPORT_STATUS_READY: 'ready',
    EXPORT_STATUS_FAILED: 'failed',
    EXPORT_STATUS_EXPORTED: 'exported',
    EXPORT_STATUS_NOT_EXPORTED: 'not_exported',
    CONFIRMATION_STATUS_CONFIRMED: 'confirmed',
    CONFIRMATION_STATUS_NOT_CONFIRMED: 'not_confirmed'
})

export const APPLICATION_VERSION = '2.0.1'

// recaptcha score
export const RECAPTCHA_SCORE = 0.5

// recaptcha validation url
export const RECAPTCHA_VALIDATION_URL = 'https://www.google.com/recaptcha/api/siteverify'

// SEO
export const PATH_SEPARATOR = '/'
export const COLOR_ID_SEPARATOR = '-'
export const CURRENT_CATEGORY_PATH_PREFIX = 'category'
export const CATEGORY_PATH_PREFIX = 'c'
export const PRODUCT_PATH_PREFIX = 'p'
export const CURRENT_PRODUCT_PATH_PREFIX = 'product'
export const PRODUCT_SET_PATH_PREFIX = 'ps'
export const OUTLET_PATH_PREFIX = 'outlet-'
export const LEGACY_STORE_PATH = 'store-details'
export const LEGACY_CN_LOCALE_ID = 'cn'
export const EN_LOCALE_ID = 'en'

// Payment Method IDs
export const GC_PAYMENT_METHOD_ID = 'GIFT_CERTIFICATE'

// GTM Related
export const GTM_GC_PAYMENT_ID = 'gc'

// List of countries that use the RHT pricebook
export const COUNTRIES_USING_RHT_PRICEBOOK = [
    'ER',
    'ET',
    'GQ',
    'TD',
    'EG',
    'MW',
    'BF',
    'BW',
    'BJ',
    'AO',
    'ZA',
    'AE',
    'TH',
    'GM',
    'KE',
    'JO',
    'GA',
    'NE',
    'TW',
    'RE',
    'KH',
    'NZ',
    'FJ',
    'KR',
    'RW',
    'MU',
    'MA',
    'BD',
    'TG',
    'UG',
    'LK',
    'NG',
    'LS',
    'AW',
    'TZ',
    'ML',
    'VN',
    'BH',
    'IL',
    'MN',
    'BT',
    'MY',
    'OM',
    'BN',
    'QA',
    'MZ',
    'MV',
    'LA',
    'PH',
    'PK',
    'ID',
    'SA',
    'MG',
    'KW',
    'PG',
    'TK',
    'BB',
    'VU',
    'BO',
    'AI',
    'AG',
    'AR',
    'BZ',
    'BM',
    'BR',
    'VG',
    'KY',
    'CL',
    'CO',
    'CR',
    'GF',
    'DM',
    'EC',
    'DO',
    'SV',
    'GD',
    'GP',
    'GT',
    'GY',
    'HN',
    'MQ',
    'JM',
    'MS',
    'NI',
    'PA',
    'PY',
    'PE',
    'LC',
    'BL',
    'VC',
    'TT',
    'TC',
    'UY',
    'AL',
    'BA',
    'GI',
    'IS',
    'NO',
    'SM',
    'RS',
    'ZM',
    'ME',
    'HT',
    'CW',
    'AX'
]
export const DEFAULT_COMMON_PATH_OBJ = {
    isOutletSite: false,
    websiteCode: 'eu',
    language: 'en'
}
// PDP Regexes
export const PDP_REGEX_WITH_PRODUCT_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(product)\/([^/]+)/i
export const PDP_REGEX_WITH_CATEGORY_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(p)\/([^/]+)\/([^/]+)/i
export const PDP_REGEX_WITH_QUERY_PARAM =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\w+)\.html\?dwvar_(\w+)_color=(\w+)/i
export const PDP_REGEX_WITH_WB_PREFIX =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/[wW][bB]-(\w+)-(\w+)\.html(\?dwvar_[wW][bB]-(\w+)-(\w+)_color=(\w+))?/i
export const PDP_REGEX_WITH_DIGITS_EAN = /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\d{13})\.html$/i
export const PDP_REGEX_CANONICAL = /^\/(outlet-)?(\w{2})\/(\w{2})\/([^/]+)\/(\w+)\.html$/i
export const ORDER_CONFIRMATION_PATH =
    /^\/(outlet-)?(\w{2})\/(\w{2})\/(checkout)\/(confirmation)\/([^/]+)/i
export const ORDER_HISTORY_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(account)\/(orders)\/([^/]+)/i
export const ORDER_INVOICE_PATH = /^\/(outlet-)?(\w{2})\/(\w{2})\/(invoice)\/([^/]+)/i

// Refund Related
export const REFUND_BUSINESS_RESOLUTION_STEPS = [
    'Resolution steps: it depends on the refusal reason given by Adyen',
    'Not enough funds on account → see with finance, business process',
    'Not enough remaining amount on order → check in Adyen and ask IT for help if needed',
    'Refund is blocked by an action from the customer → business process',
    'Other → check the reason and in Adyen, then ask IT for help if needed'
]

export const PDP_REGEX_FOR_MASTER_PRODUCT = /^[A-Z0-9]{8}$/
export const PDP_REGEX_FOR_VARIATION_GROUP = /^[A-Z0-9]{8}-\d{3}$/
export const PDP_REGEX_FOR_VARIANT = /^\d{13}$/
